import { render, staticRenderFns } from "./BranchCollection.vue?vue&type=template&id=14c4c802"
import script from "./BranchCollection.vue?vue&type=script&lang=js"
export * from "./BranchCollection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports